import React, { useState } from 'react';
import { SupplierDetails } from '../../../data/models/product_list_response';
import { icons } from '../../../assets/assets';

const SupplierDetailsModal = (supplier: SupplierDetails) => {
  const [showSupplierModal, setShowSupplierModal] = useState(false);

  return (
    <>
      <button className="text-primaryViolet" onClick={() => setShowSupplierModal(true)}>
        {'Supplier Name'}
      </button>
      <div className="text-left">
        {showSupplierModal ? (
          <div
            className="modal bg-theDarkOne bg-opacity-25 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto transition-all"
            id="supplierDetailsModal"
            aria-labelledby="supplierDetailsModalTitle"
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered relative w-4/5 mx-auto top-1/4 max-w-[450px]">
              <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md">
                  <h5 className="text-lg font-medium leading-normal text-theDarkOne" id="exampleModalScrollableLabel">
                    {'Supplier Name'}
                  </h5>
                  <button
                    type="button"
                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setShowSupplierModal(false);
                    }}
                  >
                    <img src={icons.CloseIcon} className="object-cover h-6 w-6" />
                  </button>
                </div>
                <div className="modal-body relative p-4">
                  <div className="mb-3 xl:w-96">
                    <p className="w-full text-left">
                      {
                        'Supplier description, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
                      }
                    </p>
                  </div>
                </div>
                {/* <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setShowModal(false);
                        updateCartQuantity(props.product, updatedQuantity ?? 0);
                      }}
                      className="inline-block px-6 py-2.5 bg-primaryViolet text-white font-medium text-xs leading-tight uppercase rounded-lg shadow-md hover:bg-primaryViolet focus:bg-primaryViolet focus:outline-none focus:ring-0 active:bg-primaryViolet active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Save
                    </button>
                  </div> */}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default SupplierDetailsModal;